import { Camera } from "three";
import { OrthographicCamera } from "./OrthographicCamera";
import { PerspectiveCamera } from "./PerspectiveCamera";
import { CameraProjection } from "../../../api";
export class CompositeCamera extends Camera {
    constructor(fov, aspect, near, far) {
        super();
        this.perspective = new PerspectiveCamera(fov, aspect, near, far);
        this.orthographic = new OrthographicCamera(-1, 1, 1, -1, near, Math.min(far, CompositeCamera.ORTHOGRAPHIC_MAX_FAR));
        this.currentCamera = this.perspective;
        this.orthographic.setAspectRatio(aspect);
        this.add(this.perspective);
        this.add(this.orthographic);
    }
    setProjectionMode(mode) {
        if (mode === CameraProjection.Orthographic) {
            this.currentCamera = this.orthographic;
        }
        else {
            this.currentCamera = this.perspective;
        }
    }
    getProjectionMode() {
        if (this.currentCamera === this.orthographic) {
            return CameraProjection.Orthographic;
        }
        else {
            return CameraProjection.Perspective;
        }
    }
    getCurrentCamera() {
        return this.currentCamera;
    }
}
CompositeCamera.ORTHOGRAPHIC_MAX_FAR = 50000;
